import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './routes/Home';
import Snap from './routes/Snap';
import Type from './routes/Type';
import Browse from './routes/Browse';
import Solve from './routes/Solve';
import Progress from './routes/Progress';
import ParentLogin from './routes/parent/Login';
import ParentDashboard from './routes/parent/Dashboard';
import RequireAuth from './routes/parent/RequireAuth';
import TabBar from './components/TabBar';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 pb-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/snap" element={<Snap />} />
          <Route path="/type" element={<Type />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/solve" element={<Solve />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/parent/login" element={<ParentLogin />} />
          <Route
            path="/parent"
            element={
              <RequireAuth>
                <ParentDashboard />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <TabBar />
    </div>
  );
}
